<template>
  <div>
    <b-row align-h="center">
      <FITFormCard class="w-50">
        <div slot="header">
          <p class="h5">{{$t('my.changePassword.header')}}</p>
        </div>
        <div slot="formBody">
          <b-alert :show="error.hasError" variant="danger"><i class="fa fa-exclamation-circle mr-2"></i>{{ error.errorMessage }}</b-alert>
          <b-alert :show="success" variant="success"><i class="fa fa-check-circle mr-2"></i>{{ $t('my.changePassword.success') }}</b-alert>
          <b-row>
            <b-col cols="12">
              <FITTextInput type="password" :label="$t('my.changePassword.oldPassword')" :placeholder="$t('my.changePassword.oldPassword')" v-model="form.oldPassword" />
              <FITTextInput type="password" :label="$t('my.changePassword.newPassword')" :placeholder="$t('my.changePassword.newPassword')" v-model="form.newPassword" />
              <FITTextInput type="password" :label="$t('my.changePassword.confirmNewPassword')" :placeholder="$t('my.changePassword.confirmNewPassword')" v-model="form.confirmNewPassword" />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="text-right">
              <FITButton :text="$t('my.changePassword.changePassword')" variant="primary" faIcon="fa-key" @click="changePassword"></FITButton>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import {
  FITTextInput,
  FITButton,
  FITFormCard,
  FITValidationBus
} from '@/components';

export default {
  name: 'ChangePassword',
  components: {
    FITTextInput,
    FITButton,
    FITFormCard
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      error: {
        hasError: false,
        errorMessage: 'Error Message'
      },
      success: false
    }
  },
  methods: {
    changePassword() {
      this.$store.dispatch('My/changePassword', this.form)
        .then((json) => {
          Vue.set(this, 'success', true);
          Vue.set(this.error, 'hasError', false);
          Vue.set(this, 'form', {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: ''
          });
           FITValidationBus.$emit('reset',true);
          this.$router.replace('/');
        })
        .catch((err) => {
          Vue.set(this.error, 'hasError', true);
        })
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/My/components/Profile/ChangePassword.vue